export const fetchSpotifyPlaylistTracks = async (playlistId) => {
  const accessToken = localStorage.getItem("accessToken");
  if (!accessToken) throw new Error("Spotify token missing");

  const tracks = [];
  let nextUrl = `https://api.spotify.com/v1/playlists/${playlistId}/tracks?limit=100`;

  try {
    while (nextUrl) {
      const res = await fetch(nextUrl, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      const data = await res.json();
      if (!data.items) {
        console.error("Spotify API error:", data);
        break;
      }
      tracks.push(
        ...data.items.map((item) => ({
          title: item.track?.name,
          artist: item.track?.artists?.map((a) => a.name).join(", ") || "",
          id: item.track?.id,
          uri: item.track?.uri,
          thumbnail: item.track?.album?.images?.[0]?.url || null,
          duration: item.track?.duration_ms ? Math.round(item.track.duration_ms / 1000) : 0,
        }))
      );
      nextUrl = data.next;
    }
  } catch (err) {
    console.error("fetchSpotifyPlaylistTracks failed:", err);
  }

  return tracks;
}; 